import { createFileRoute } from '@tanstack/react-router';

import { NexusProjectList } from '@/features/nexus/NexusProjectList';
import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/nexus/')({
  component: NexusListRoute,
});

function NexusListRoute() {
  return (
    <PageLayout>
      <NexusProjectList />
    </PageLayout>
  );
}
